module.exports = __webpack_public_path__ + "assets/img/recommend_icon05.b12ac0ca.png";